import BookingForm from "@/components/BookingForm";
import SharedNavbar from "@/components/SharedNavbar";
import { CheckCircle2, Zap, Truck, Wrench, ShieldCheck, Phone, ArrowRight } from "lucide-react";

const LOGO_URL =
  "https://skyagent-artifacts.skywork.ai/router/agent/2026-06-23/prod_agent_3a0812e8-cabc-4e60-9023-9eb878dbad11/ds_logo_transparent_1343324419e041449c280c0bfa45d1f3.png";

const PHOTOS = [
  "https://images.unsplash.com/photo-1588854337115-1c67d9247e4d?w=900&q=80",
  "https://images.unsplash.com/photo-1622473590925-e3616c0a41bf?w=900&q=80",
  "https://images.unsplash.com/photo-1722859178634-ccc8ea5680d2?w=900&q=80",
  "https://images.unsplash.com/photo-1597418048367-7dd01e4404ee?w=900&q=80",
  "https://images.unsplash.com/photo-1585314293845-4db3b9d0c6e9?w=900&q=80",
  "https://images.unsplash.com/photo-1751945965248-70b952b11193?w=900&q=80",
];

const HERO_PHOTO = "https://images.unsplash.com/photo-1722859178634-ccc8ea5680d2?w=1400&q=85";

export default function Elektro() {
  return (
    <div className="min-h-screen bg-background">
      <SharedNavbar />

      {/* Hero */}
      <section className="relative h-[55vh] overflow-hidden">
        <img src={HERO_PHOTO} alt="Haushaltsgeräte Transport" className="w-full h-full object-cover object-center" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/45 to-transparent" />
        <div className="absolute inset-0 flex items-end">
          <div className="mx-auto max-w-7xl px-5 pb-12 lg:px-8">
            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-4 py-1.5 text-xs font-semibold uppercase tracking-widest text-white/80 mb-4">
              <Zap className="h-3.5 w-3.5 text-red-400" />
              Elektro & Weissware
            </div>
            <h1 className="text-4xl font-bold text-white sm:text-5xl leading-tight">
              Haushaltsgeräte —<br />
              <span className="text-red-400">Transport & Installation</span>
            </h1>
            <p className="mt-3 text-white/75 text-lg max-w-2xl">
              Von der Kühl-Gefrier-Kombination bis zum Induktionsherd — DS Logistik transportiert, installiert und nimmt alle Ihre Haushaltsgeräte fachgerecht in Betrieb.
            </p>
          </div>
        </div>
      </section>

      {/* Was wir bieten */}
      <section className="py-20">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="grid gap-14 lg:grid-cols-2 lg:items-center">
            {/* Text */}
            <div>
              <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-primary">Unser Service</p>
              <h2 className="mt-3 text-3xl font-bold text-foreground sm:text-4xl leading-tight">
                Professioneller Transport & fachgerechte Installation
              </h2>
              <p className="mt-5 text-muted-foreground leading-relaxed text-base">
                DS Logistik ist Ihr verlässlicher Partner für die Lieferung und Installation aller Haushaltsgeräte — direkt beim Endkunden. Ob Kühlschrank, Waschmaschine, Geschirrspüler, Herd oder Tumbler: Unser geschultes Team transportiert Ihre Geräte sicher, schleppt sie bis in die gewünschte Etage und nimmt sie fachgerecht in Betrieb.
              </p>
              <p className="mt-4 text-muted-foreground leading-relaxed text-base">
                Mit langjähriger Erfahrung in der Schweizer Haushaltsgeräte-Logistik kennen wir die hohen Anforderungen der Weissware-Logistik genau. Präzision beim Anschluss, Sauberkeit im Treppenhaus und Pünktlichkeit beim Liefertermin sind für uns selbstverständlich.
              </p>
              <div className="mt-8 space-y-3">
              <button
                onClick={() => { const el = document.getElementById("termin-anfragen"); if(el){ el.scrollIntoView({behavior:"smooth",block:"start"}); setTimeout(()=>{ const f = document.getElementById("booking-name"); if(f) f.focus(); }, 600); }}}
                className="inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-bold text-white shadow-[0_8px_24px_-10px_rgba(200,25,11,0.6)] hover:-translate-y-px transition-all w-fit"
              >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M8 2v4M16 2v4M3 10h18M5 4h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"/></svg>
                Jetzt anfragen
              </button>
                {[
                  { icon: Truck,       text: "Sicherer Transport — vom Lager direkt zum Kunden, auch in obere Stockwerke" },
                  { icon: Wrench,      text: "Fachgerechter Anschluss von Wasser, Strom und Abluft durch unser Montageteam" },
                  { icon: Zap,         text: "Inbetriebnahme und Funktionskontrolle aller Geräte vor Ort" },
                  { icon: ShieldCheck, text: "Entsorgung der Verpackung und des alten Geräts auf Wunsch" },
                ].map(({ icon: Icon, text }) => (
                  <div key={text} className="flex items-start gap-3">
                    <div className="mt-0.5 rounded-xl bg-primary/10 p-2 text-primary shrink-0">
                      <Icon className="h-4 w-4" />
                    </div>
                    <p className="text-sm text-muted-foreground leading-6">{text}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Foto grid 3x2 */}
            <div className="grid grid-cols-2 gap-3 sm:grid-cols-3">
              {PHOTOS.map((src, i) => (
                <div key={i} className={`overflow-hidden rounded-2xl ${i % 3 === 1 ? "mt-5" : ""}`} style={{ boxShadow: "0 16px 40px -20px rgba(37,10,8,0.25)" }}>
                  <img src={src} alt={`Haushaltsgeräte ${i + 1}`} className="h-44 w-full object-cover hover:scale-105 transition-transform duration-500" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Geräte-Kategorien */}
      <section className="py-16 bg-muted/30 border-y border-border/40">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="text-center mb-12">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-primary">Alle Gerätetypen</p>
            <h2 className="mt-3 text-3xl font-bold text-foreground sm:text-4xl">Unsere Geräte-Kategorien</h2>
            <p className="mt-3 text-muted-foreground max-w-2xl mx-auto">
              Wir liefern und installieren alle gängigen Haushaltsgeräte — direkt beim Endkunden, zuverlässig und fachgerecht.
            </p>
          </div>
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {[
              {
                emoji: "🧊",
                title: "Kühl- & Gefriergeräte",
                items: ["Kühlschränke", "Gefrierschränke", "Kühl-Gefrier-Kombis", "Weinkühlschränke"],
              },
              {
                emoji: "🫧",
                title: "Wasch- & Trockengeräte",
                items: ["Waschmaschinen", "Tumbler / Wäschetrockner", "Waschturm-Kombinationen", "Geschirrspüler"],
              },
              {
                emoji: "🍳",
                title: "Kochen & Backen",
                items: ["Elektroherde", "Induktionskochfelder", "Backöfen", "Dampfgarer & Kombigeräte"],
              },
              {
                emoji: "📺",
                title: "Unterhaltung & Technik",
                items: ["Fernseher & Displays", "Haushalt-Kleingeräte", "Kaffeemaschinen", "Klimaanlagen"],
              },
            ].map(({ emoji, title, items }) => (
              <div key={title} className="rounded-3xl border border-border/60 bg-card p-6" style={{ boxShadow: "0 12px 30px -18px rgba(37,10,8,0.16)" }}>
                <div className="text-4xl mb-4">{emoji}</div>
                <h3 className="text-base font-bold text-foreground mb-3">{title}</h3>
                <ul className="space-y-1.5">
                  {items.map((item) => (
                    <li key={item} className="flex items-center gap-2 text-sm text-muted-foreground">
                      <CheckCircle2 className="h-3.5 w-3.5 shrink-0 text-primary" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Ablauf */}
      <section className="py-16">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="text-center mb-12">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-primary">So läuft es ab</p>
            <h2 className="mt-3 text-3xl font-bold text-foreground sm:text-4xl">Von der Bestellung bis zur Inbetriebnahme</h2>
          </div>
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
            {[
              { num: "01", title: "Abholung im Lager",        text: "Wir holen Ihre Geräte direkt aus dem Händlerlager ab — sicher verpackt und transportgesichert." },
              { num: "02", title: "Transport zum Kunden",     text: "Pünktliche Lieferung zum vereinbarten Termin, mit Vorabanruf und Treppenhausschutz." },
              { num: "03", title: "Installation & Anschluss", text: "Fachgerechter Wasser-, Strom- und Ablufanschluss durch unser geschultes Montageteam." },
              { num: "04", title: "Inbetriebnahme",           text: "Funktionskontrolle, Einweisung des Kunden und Entsorgung aller Verpackungsmaterialien." },
            ].map(({ num, title, text }) => (
              <div key={num} className="rounded-3xl border border-border/60 bg-card p-6" style={{ boxShadow: "0 12px 30px -18px rgba(37,10,8,0.16)" }}>
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10 font-mono text-sm font-bold text-primary mb-4">
                  {num}
                </span>
                <h3 className="text-base font-bold text-foreground">{title}</h3>
                <p className="mt-2 text-sm leading-6 text-muted-foreground">{text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Warum DS Logistik */}
      <section className="py-12">
        <div className="mx-auto max-w-7xl px-5 lg:px-8">
          <div className="rounded-3xl bg-primary/5 border border-primary/20 p-8 sm:p-12">
            <div className="grid gap-8 lg:grid-cols-2 lg:items-center">
              <div>
                <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-primary mb-3">Warum DS Logistik</p>
                <h2 className="text-2xl font-bold text-foreground sm:text-3xl">Weissware-Logistik mit System</h2>
                <p className="mt-4 text-muted-foreground leading-relaxed text-sm">
                  Mit über 20 Jahren Erfahrung in der Schweizer Haushaltsgeräte-Logistik kennen wir jede Herausforderung — vom engen Treppenhaus bis zum Altbauanschluss. Unser Team liefert täglich hunderte Geräte pünktlich, sicher und professionell installiert.
                </p>
              </div>
              <div className="grid gap-3 sm:grid-cols-2">
                {[
                  "350+ ausgebildete Mitarbeitende",
                  "Tägliche Liefertouren in der ganzen Schweiz",
                  "Erfahrung mit allen Hersteller-Standards",
                  "Treppenschutz & Einzugsschutz inklusive",
                  "Alte Geräte-Entsorgung auf Wunsch",
                  "Langjährige Erfahrung in der Schweiz",
                ].map((item) => (
                  <div key={item} className="flex items-center gap-2 text-sm text-muted-foreground">
                    <CheckCircle2 className="h-4 w-4 shrink-0 text-primary" />
                    {item}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      
      {/* Termin & Anfrage */}
      <section className="py-16 bg-muted/30 border-y border-border/40">
        <div className="mx-auto max-w-3xl px-5 lg:px-8">
          <div className="text-center mb-10">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-primary">Jetzt buchen</p>
            <h2 className="mt-3 text-3xl font-bold text-foreground">Termin anfragen</h2>
            <p className="mt-3 text-muted-foreground">Wählen Sie Service, Datum und Uhrzeit — wir melden uns innerhalb von 24 Stunden.</p>
          </div>
          <BookingForm defaultService="Elektro & Haushaltsgeräte" />
        </div>
      </section>

      {/* CTA */}
      <section className="py-16 bg-slate-900 text-white">
        <div className="mx-auto max-w-2xl px-5 lg:px-8 text-center">
          <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-red-400 mb-3">Jetzt anfragen</p>
          <h2 className="text-3xl font-bold">Gerätelieferung planen?</h2>
          <p className="mt-3 text-white/70">Kontaktieren Sie uns für ein unverbindliches Angebot. Wir beraten Sie gerne.</p>
          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <a href="tel:+41326712010" className="inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-bold text-white shadow-[0_8px_24px_-10px_rgba(200,25,11,0.7)] hover:-translate-y-px transition-all">
              <Phone className="h-4 w-4" /> 032 671 20 10
            </a>
            <a href="https://wa.me/41798883262" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-6 py-3 text-sm font-bold text-white hover:scale-105 transition-transform">
              <svg viewBox="0 0 24 24" className="h-4 w-4 fill-white"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
              WhatsApp
            </a>
            <a href="mailto:andre.stalder@ds-logistik.ch?subject=Anfrage%20Elektro%20%26%20Haushaltsger%C3%A4te"
              className="inline-flex items-center gap-2 rounded-full border border-white/30 px-6 py-3 text-sm font-semibold text-white hover:bg-white/10 transition-colors">
              <ArrowRight className="h-4 w-4 text-red-400" /> Per E-Mail anfragen
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-border/40 bg-background py-6 text-center">
        <p className="text-xs text-muted-foreground">
          © {new Date().getFullYear()} DS Logistik · Bielstrasse 20, 4500 Solothurn ·{" "}
          <a href="/#/impressum" className="hover:text-primary">Impressum</a>
        </p>
      </footer>

      {/* WhatsApp floating */}
      <a href="https://wa.me/41798883262" target="_blank" rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-white shadow-lg hover:scale-105 transition-transform">
        <svg viewBox="0 0 24 24" className="h-6 w-6 fill-white"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
        <span className="text-sm font-bold">WhatsApp</span>
      </a>
    </div>
  );
}
